module.exports = __webpack_public_path__ + "assets/img/54757b2911c75b1186e569c2c45184e6.svg";